export { mergeAssetsForDebug } from '../../../../services/planningTax/assetDebugSnapshot';

const CASHFLOW_IMPACT_METRIC = { id: 'cashflowImpact', label: 'Impact sur le cashflow' };
const CASHFLOW_PERSONNEL_METRIC = { id: 'cashflowImpactPersonnel', label: 'Impact cashflow (personnel)' };
const CASHFLOW_CORP_METRIC = { id: 'cashflowImpactCorporation', label: 'Impact cashflow (Inc.)' };

const CASHFLOW_METRICS = [CASHFLOW_IMPACT_METRIC, CASHFLOW_PERSONNEL_METRIC, CASHFLOW_CORP_METRIC];

export const ASSET_DEBUG_METRICS = {
  immobilier: [
    ...CASHFLOW_METRICS,
    { id: 'rentalNetAfterTax', label: 'Revenu net immeuble (après impôt)' },
    { id: 'debtService', label: 'Service de la dette liée' },
    { id: 'balance', label: 'Valeur marchande' },
  ],
  assurance_participative: [
    ...CASHFLOW_METRICS,
    { id: 'premiumPaid', label: 'Prime annuelle payée' },
    { id: 'loanInterestAnnual', label: 'Intérêt prêt collatéral (annuel)' },
    { id: 'deductibleInterestAnnual', label: 'Intérêts déductibles' },
    { id: 'interestTaxShield', label: 'Économie d\'impôt (intérêts)' },
    { id: 'quebecInterestCapped', label: 'Intérêts non déd. (plafond QC)' },
    { id: 'netPremiumAfterInterest', label: 'Prime − intérêt prêt' },
    { id: 'premiumPlusInterest', label: 'Prime + intérêt (brut)' },
    { id: 'surrenderValue', label: 'Valeur de rachat' },
    { id: 'collateralLoanBalance', label: 'Prêt collatéral (solde)' },
    { id: 'totalInsurance', label: 'Capital décès' },
    { id: 'cashValue', label: 'Solde comptable (VR)' },
    { id: 'cbr', label: 'CBR estimé' },
  ],
  default: [
    ...CASHFLOW_METRICS,
    { id: 'balance', label: 'Solde / valeur' },
  ],
};

export function getMetricsForAssetType(type) {
  return ASSET_DEBUG_METRICS[type] || ASSET_DEBUG_METRICS.default;
}

const CASHFLOW_METRIC_IDS = new Set([
  'cashflowImpact',
  'cashflowImpactPersonnel',
  'cashflowImpactCorporation',
]);

export function isCashflowMetricId(metricId) {
  return CASHFLOW_METRIC_IDS.has(metricId);
}

export function getDebugValue(snapshot, metricId) {
  if (!snapshot) return null;
  if (metricId === 'cashflowImpactPersonnel' && snapshot.entityType === 'corporation') return null;
  if (metricId === 'cashflowImpactCorporation' && snapshot.entityType === 'personnel') return null;
  const v = snapshot[metricId];
  return v == null ? null : v;
}
